import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _cancelExportAsyncJobRequest = {};
var _cancelExportAsyncJobResponse = { job: '_exportAsyncJob' };
var _createExportAsyncJobRequest = {};
var _createExportAsyncJobResponse = { job: '_exportAsyncJob' };
var _exportAsyncJob = {
    createDate: 'google.protobuf.Timestamp',
    updateDate: 'google.protobuf.Timestamp',
};
var _generateExportAsyncJobDownloadUrlRequest = {};
var _generateExportAsyncJobDownloadUrlResponse = { job: '_exportAsyncJob' };
var _getExportAsyncJobRequest = {};
var _getExportAsyncJobResponse = { job: '_exportAsyncJob' };
function resolveWixFedinfraExportserviceV1ExportServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/export-service',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/export-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/export-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/export-service',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/export-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new Export */
export function createExportAsyncJob(payload) {
    var _a = serializer(_createExportAsyncJobRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createExportAsyncJobResponse, {
        _exportAsyncJob: _exportAsyncJob,
    }).fromJSON;
    function __createExportAsyncJob(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.fedinfra.exportservice.v1.export_async_job',
            method: 'POST',
            methodFqn: 'wix.fedinfra.exportservice.v1.ExportService.CreateExportAsyncJob',
            url: resolveWixFedinfraExportserviceV1ExportServiceUrl({
                protoPath: '/v1/export-async-job',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createExportAsyncJob.fromReq = fromReq;
    __createExportAsyncJob.__isAmbassador = true;
    return __createExportAsyncJob;
}
/** Get a Export by id */
export function getExportAsyncJob(payload) {
    var _a = serializer(_getExportAsyncJobRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getExportAsyncJobResponse, {
        _exportAsyncJob: _exportAsyncJob,
    }).fromJSON;
    function __getExportAsyncJob(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.fedinfra.exportservice.v1.export_async_job',
            method: 'GET',
            methodFqn: 'wix.fedinfra.exportservice.v1.ExportService.GetExportAsyncJob',
            url: resolveWixFedinfraExportserviceV1ExportServiceUrl({
                protoPath: '/v1/export-async-job/{jobId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getExportAsyncJob.fromReq = fromReq;
    __getExportAsyncJob.__isAmbassador = true;
    return __getExportAsyncJob;
}
export function cancelExportAsyncJob(payload) {
    var _a = serializer(_cancelExportAsyncJobRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelExportAsyncJobResponse, {
        _exportAsyncJob: _exportAsyncJob,
    }).fromJSON;
    function __cancelExportAsyncJob(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.fedinfra.exportservice.v1.export_async_job',
            method: 'PUT',
            methodFqn: 'wix.fedinfra.exportservice.v1.ExportService.CancelExportAsyncJob',
            url: resolveWixFedinfraExportserviceV1ExportServiceUrl({
                protoPath: '/v1/export-async-job/{jobId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelExportAsyncJob.fromReq = fromReq;
    __cancelExportAsyncJob.__isAmbassador = true;
    return __cancelExportAsyncJob;
}
export function generateExportAsyncJobDownloadUrl(payload) {
    var _a = serializer(_generateExportAsyncJobDownloadUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateExportAsyncJobDownloadUrlResponse, { _exportAsyncJob: _exportAsyncJob }).fromJSON;
    function __generateExportAsyncJobDownloadUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.fedinfra.exportservice.v1.export_async_job',
            method: 'PUT',
            methodFqn: 'wix.fedinfra.exportservice.v1.ExportService.GenerateExportAsyncJobDownloadUrl',
            url: resolveWixFedinfraExportserviceV1ExportServiceUrl({
                protoPath: '/v1/export-async-job/{jobId}/generate-download-url',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateExportAsyncJobDownloadUrl.fromReq = fromReq;
    __generateExportAsyncJobDownloadUrl.__isAmbassador = true;
    return __generateExportAsyncJobDownloadUrl;
}
//# sourceMappingURL=http.impl.js.map